import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { F } from "@/components/ajustes/Field";

export const AiModelsPanel = ({ s, sec, models }) => (
  <>
    <F label="Modelo general" hint="Se usa cuando una tarea no tiene modelo propio.">
      <select className="w-full h-10 border border-input bg-background px-3 text-sm rounded-md"
        value={s.ai?.model || ""} onChange={(e) => sec("ai", "model", e.target.value)} data-testid="ai-model-select">
        {(models?.models || []).map((m) => <option key={m.id} value={m.id}>{m.label}</option>)}
      </select>
    </F>
    {[["model_article", "Redacción de la noticia"],
      ["model_seo", "Auditoría SEO"],
      ["model_digest", "Boletines y resúmenes"],
      ["model_social", "Textos para redes"]].map(([key, label]) => (
      <F key={key} label={`Modelo · ${label}`}>
        <select className="w-full h-10 border border-input bg-background px-3 text-sm rounded-md"
          value={s.ai?.[key] || ""} onChange={(e) => sec("ai", key, e.target.value)}
          data-testid={`ai-${key.replace("model_", "")}-select`}>
          <option value="">Usar el modelo general</option>
          {(models?.models || []).map((m) => <option key={m.id} value={m.id}>{m.label}</option>)}
        </select>
      </F>
    ))}
    <p className="text-xs text-muted-foreground mb-4">
      Cada medio puede tener su propio modelo de redacción en Medios → Configurar, y tiene
      prioridad sobre estos ajustes.
    </p>
  </>
);

export const AiInstructions = ({ s, sec }) => (
  <F label="Instrucciones editoriales permanentes" hint="Se aplican a toda noticia generada por la IA.">
    <Textarea rows={5} value={s.ai?.instructions || ""} onChange={(e) => sec("ai", "instructions", e.target.value)} data-testid="ai-instructions-input" />
  </F>
);

export const AiUsagePanel = ({ s, sec, models, usage, cheapest }) => (
  <div className="border-t border-border pt-4 mt-2" data-testid="ai-usage-panel">
    <div className="kicker mb-2">Consumo de IA · últimos 30 días</div>
    {!usage?.models?.length && (
      <p className="text-xs text-muted-foreground" data-testid="ai-usage-empty">
        Aún no hay notas redactadas en este periodo. En cuanto redacte con la IA verá aquí el
        costo por nota de cada modelo.
      </p>
    )}
    {usage?.models?.length > 0 && (
      <>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider text-muted-foreground">
                <th className="py-2">Modelo</th>
                <th className="py-2">Notas</th>
                <th className="py-2">Costo por nota</th>
                <th className="py-2">Total</th>
                <th className="py-2">Tiempo medio</th>
              </tr>
            </thead>
            <tbody>
              {usage.models.map((m) => (
                <tr key={m.model} className="border-t border-border"
                    data-testid={`usage-${m.model}`}>
                  <td className="py-2 pr-3">{m.label}</td>
                  <td className="py-2 mono">{m.calls}</td>
                  <td className="py-2 mono">US$ {m.cost_per_call.toFixed(4)}</td>
                  <td className="py-2 mono">US$ {m.cost_usd.toFixed(3)}</td>
                  <td className="py-2 mono">{m.avg_seconds}s</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-muted-foreground mt-2">
          Total del periodo: <strong>US$ {usage.total_cost_usd.toFixed(3)}</strong> en
          {" "}{usage.total_calls} llamada(s). El más económico por nota es{" "}
          <strong>{cheapest?.label}</strong>.
        </p>
      </>
    )}
    <div className="kicker mt-4 mb-2">Precios por millón de tokens (editable)</div>
    <div className="grid sm:grid-cols-2 gap-2">
      {(models?.models || []).map((m) => (
        <div key={m.id} className="flex items-center gap-2">
          <span className="text-xs flex-1 truncate">{m.id}</span>
          <Input className="w-20 h-8" type="number" step="0.01"
            value={s.ai?.prices?.[m.id]?.in ?? 0}
            onChange={(e) => sec("ai", "prices", {
              ...(s.ai?.prices || {}),
              [m.id]: { ...(s.ai?.prices?.[m.id] || {}), in: Number(e.target.value) },
            })}
            data-testid={`price-in-${m.id}`} />
          <Input className="w-20 h-8" type="number" step="0.01"
            value={s.ai?.prices?.[m.id]?.out ?? 0}
            onChange={(e) => sec("ai", "prices", {
              ...(s.ai?.prices || {}),
              [m.id]: { ...(s.ai?.prices?.[m.id] || {}), out: Number(e.target.value) },
            })}
            data-testid={`price-out-${m.id}`} />
        </div>
      ))}
    </div>
    <p className="text-xs text-muted-foreground mt-1">
      Primer campo: entrada · segundo campo: salida, en dólares por millón de tokens.
      Los tokens se estiman a partir del texto, así que el costo es aproximado.
    </p>
  </div>
);
